(function() {
  const swiperTestimonials = document.querySelector('.with-swipe-slides');
  if(swiperTestimonials){
    const sliders_section = document.querySelectorAll(".with-swipe-slides");
    
    
    sliders_section.forEach(function(element) {
      let mobile_size = 1.2;
      const slider_element = element.querySelector('.swiper_testimonials');
      let navigation_left = '';
      let navigation_right = '';
      const navigation_container = element.querySelector('.navigation-container');
      if(navigation_container){
          navigation_left = `#${navigation_container.id} .swiper-button-prev`;
          navigation_right = `#${navigation_container.id} .swiper-button-next`;
      }
      const idValue = `#${slider_element.id}`;
      const desktop_slide = parseFloat(slider_element.dataset.koh_slides);
      const super_desktop = Math.round(desktop_slide);
      console.log(super_desktop);
      if (slider_element && slider_element.hasAttribute('data-koh_mobile_slides')) {
        mobile_size = parseFloat(slider_element.dataset.koh_mobile_slides);
      }
      console.log(mobile_size);
      var swiper = new Swiper(idValue, {
          slidesPerView: 3,
          centeredSlides: true,
          pagination: {
            el: `${idValue} .swiper-pagination`,
            clickable: true,
          },
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: mobile_size,
              centeredSlides: true,
              loop: true,
              spaceBetween: 10,
              pagination: {
                enabled: true
              }
            },
            // when window width is >= 640px
            767: {
              slidesPerView: 2,
              centeredSlides: false,
              spaceBetween: 10,
              pagination: {
                enabled: true
              }
            },
            1279: {
              slidesPerView: desktop_slide,
              centeredSlides: false,
              spaceBetween: 18,
              pagination: {
                enabled: true
              },
              navigation: {
                nextEl: navigation_right,
                prevEl: navigation_left,
              },
            },
            1920: {
              slidesPerView: super_desktop,
              centeredSlides: false,
              spaceBetween: 18,
              pagination: {
                enabled: true
              },
              navigation: {
                nextEl: navigation_right,
                prevEl: navigation_left,
              },
            }
          }
      });
    })
  }
})();